import { render } from "./StarReviews.vue?vue&type=template&id=74467df7&scoped=true"
import script from "./StarReviews.vue?vue&type=script&lang=js"
export * from "./StarReviews.vue?vue&type=script&lang=js"

import "./StarReviews.vue?vue&type=style&index=0&id=74467df7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74467df7"]])

export default __exports__